import { Box } from '@mui/material';
import tokens, { generateColor } from '@verifime/design-tokens';
import { ReactNode } from 'react';
import { Logo, TLogoColorMode, TLogoLayout, TLogoSize } from '../Logo';

export default function SideNavLogo({
  size = 'medium',
  layout = 'horizontal',
  colorMode = 'onPrimary',
  logo,
}: {
  colorMode?: TLogoColorMode;
  layout?: TLogoLayout;
  size?: TLogoSize;
  /**
   * Custom logo component to display in the side navigation.
   * Defaults to the VerifiMe Logo if not provided.
   */
  logo?: ReactNode;
}) {
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: generateColor(tokens.brandColorPrimary, '600'),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingY: tokens.spacingBase,
        paddingX: tokens.spacingLg,
      }}
    >
      {logo ?? <Logo size={size} layout={layout} colorMode={colorMode} />}
    </Box>
  );
}
